import {FormEvent, useState} from "react";
import {Alert, Card, Form} from "react-bootstrap";
import {Link} from "react-router";
import {UsersApi} from "../api/UsersApi";
import {ErrorAlert} from "../components/ErrorAlert";
import {SubmitButton} from "../components/SubmitButton";

export function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [busy, setBusy] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState<unknown>();

    const submit = async (e: FormEvent) => {
        e.preventDefault();
        setBusy(true);
        setError(undefined);
        try {
            await UsersApi.forgotPassword(email.trim());
            setSent(true);
        } catch (err) {
            setError(err);
        } finally {
            setBusy(false);
        }
    };

    return (
        <Card className="auth-card mx-auto mt-md-4">
            <Card.Body className="p-4">
                <h1 className="h4 mb-3">Reset your password</h1>
                {sent ? (
                    // The API answers the same whether or not the address has an account.
                    <Alert variant="success">
                        If an account uses that address, we've sent it a link to reset the password. The link works
                        for 10 minutes.
                    </Alert>
                ) : (
                    <>
                        <p className="text-body-secondary">Enter your account's email address and we'll send you a link.</p>
                        <ErrorAlert error={error}/>
                        <Form onSubmit={submit}>
                            <Form.Group className="mb-4" controlId="email">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" autoComplete="email" autoFocus required value={email} onChange={e => setEmail(e.target.value)}/>
                            </Form.Group>
                            <SubmitButton busy={busy} className="w-100">Send link</SubmitButton>
                        </Form>
                    </>
                )}
                <div className="text-center mt-3">
                    <Link to="/login" className="small">Back to sign in</Link>
                </div>
            </Card.Body>
        </Card>
    );
}
